import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { DeleteOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { useSendEmail } from "../../hooks/useSendEmail";
import { actionShowSpinner } from "../../redux-flow/action/Wrapper/Spinner";
import DialogCustom from '../Common/DialogCustom';
import Textarea from "../Common/Textarea";
import { Dropzone, FieldInfo, FilesContainer } from './styles';

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel, Grid, makeStyles, TextField, Typography
} from "@material-ui/core";
import ToastMessage from '../Common/ToastMessage';

const useStyles = makeStyles(() => ({

  root: {
    flexGrow: 1,
    paddingTop: '1%',
  },

  buttonSend: {
    float: 'right',
    marginTop: '1%',
    paddingLeft: '1%',
  },
  SendIcon: {
    marginLeft: '2%'
  },
  lgpdInfoContainer: {
    display: "flex",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginTop: "16px",
  },
}));

function FormSendMeetingInvite(props) {
  const { sendInviteSlot } = useSendEmail({
    spinner: actionShowSpinner,
  });

  const [toastMessage, setToastMessage] = useState({
    message: '',
    type: 'error',
    open: false,
  });
  const [filesAnexo, setFilesAnexo] = useState([]);
  const [content, setContent] = useState(props.bodyEmail);
  const [emails, setEmails] = useState('');
  const [loading, setLoading] = useState(false);
  
  const classes = useStyles();
  let bodyTimeout = null;
  
  useEffect(() => {
    let initialEmails = '';

    const hostsEmails = (props?.data?.hosts || []).filter(host => host.email).map(host => host.email);
    const [recipients] = props?.data?.slotConfirmationRecipients;
    const recipientEmails = recipients ? recipients.split(`;`) : [];

    const emails = new Set([...recipientEmails, ...hostsEmails]);

    emails.forEach(item => {
      initialEmails += `${item};`;
    });

    setEmails(initialEmails);
  }, [props.data])

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const sendEmail = async () => {
    setLoading(true);
    
    const receiptsToSend = emails.split(';').filter(e => e.length > 5).map(item => item.replaceAll(' ', ''));

    const emailValidator = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let isEmailsValid = true

    receiptsToSend.forEach(email => {
      if (!emailValidator.test(String(email).toLowerCase())) {
        isEmailsValid = false;
      };
    })

    if (!isEmailsValid) {
      setToastMessage({
        open: true,
        message: "Email inválido.",
        type: "error",
      });

      return;
    }

    const formData = new FormData();

    let count = 0;

    for (const file of filesAnexo) {
      formData.append(`Attachments[${count}].fromFiles`, file.file);
      formData.append(`Attachments[${count}].fileType`, file.contentType);

      count += 1;
    }

    if (filesAnexo.length < 1) {
      formData.append(`Attachments`, []);
    }

    receiptsToSend.forEach((email, index) => {
      formData.append(`Recipients[${index}].Address`, email);
    });

    formData.append("meetId", props.meetingData.meetId);
    formData.append("meetDate", `${props.meetingData.meetDate.split('/')[2]}/${props.meetingData.meetDate.split('/')[1]}/${props.meetingData.meetDate.split('/')[0]}`);
    formData.append("locationName", slotLocation);
    formData.append("OnlineMeetingProvider", onlineMeet);
    formData.append("slotId", props?.data.id);
    formData.append("SlotTimeStart", props.data.meetStartTime);
    formData.append("SlotTimeEnd", props.data.meetEndTime);
    formData.append("subject", props.typeFormSend === 'Slot'
      ? `${props?.meetingData?.committeName} - ${props?.meetingData?.meetDate} - ${props.data.name.props.children }`
      : `${props?.meetingData?.committeName} - ${props?.meetingData?.meetDate} - ${props?.meetingData?.meetStartTime} - ${props?.meetingData?.meetEndTime}`
    );
    formData.append("Content", content);
    formData.append("ccRecipients", []);

    if (emails.length < 1) {
      setToastMessage({
        open: true,
        message: "Não é possível enviar esta reunião porque não há destinatários na caixa 'Para'",
        type: "error",
      });
    } else {
      const response = await sendInviteSlot(formData);

      setLoading(false);

      if (response?.error.length <= 0) {
        props.onSendEmail(receiptsToSend);
      } else {
        setToastMessage({
          open: true,
          message: "Falha no envio do e-mail",
          type: "error",
        });
      }
    }
  }

  const handleCapture = async ({ target }) => {
    const listArquivos = [];
    const filesUploadedWithSameName = [];
    const filesWithSameName = [];

    for (const file of target.files) {
      const fileBase64 = await toBase64(file);

      const itemToInclude = {
        file: file,
        id: uuidv4(),
        name: file.name,
        contentType: file.type,
        contentByte: fileBase64.split(',')[1]
      };

      const fileWithSameName = filesAnexo.find(fileAnexo => file.name === fileAnexo.name);

      if (fileWithSameName) {
        filesUploadedWithSameName.push(itemToInclude);
        filesWithSameName.push(fileWithSameName);

        setOpenUploadSameFileDialog(true);
      } else {
        listArquivos.push(itemToInclude);
      }
    }

    if (filesUploadedWithSameName) {
      setFilesUploadedWithSameName(filesUploadedWithSameName, 1);
    }

    if (filesWithSameName) {
      setSameFilesUploaded(filesWithSameName);
    }

    setFilesAnexo([...filesAnexo, ...listArquivos]);
  };

  const handleRemoveFile = (item_id) => {
    const newFiles = filesAnexo.filter(file => file.id !== item_id);

    setFilesAnexo(newFiles);
  }

  const [onlineMeet, setOnlineMeet] = useState(false);
  const [slotLocation, setSlotLocation] = useState('');

  const handleCloseUploadSameFileDialog = () => {
    setSameFilesUploaded([])
    setOpenUploadSameFileDialog(false);
  }

  const handleReplaceSameFile = () => {
    if (sameFilesUploaded.length > 0) {
      const fileIdssWithSameName = sameFilesUploaded.map(sameFile => sameFile.id)
      const newFilesAnexoList = filesAnexo.filter(file => !fileIdssWithSameName.includes(file.id));

      setFilesAnexo([...newFilesAnexoList, ...filesUploadedWithSameNameState]);
      setSameFilesUploaded([]);
      setFilesUploadedWithSameName([]);
    }

    setOpenUploadSameFileDialog(false);
  }

  const [filesUploadedWithSameNameState, setFilesUploadedWithSameName] = useState([]);
  const [sameFilesUploaded, setSameFilesUploaded] = useState([]);
  const [openUploadSameFileDialog, setOpenUploadSameFileDialog] = useState(false);

  const [fileOver, setFileOver] = useState(false);

  const dragOver = (e) => {
    setFileOver(true);

    e.preventDefault();
  }

  const dragEnter = (e) => {
    setFileOver(true);

    e.preventDefault();
  }

  const dragLeave = (e) => {
    setFileOver(false);

    e.preventDefault();
  }

  const fileDrop = async (e) => {
    setFileOver(false);
    e.preventDefault();

    const files = e.dataTransfer.files;

    const listArquivos = [];
    const filesUploadedWithSameName = [];
    const filesWithSameName = [];

    for (const file of files) {
      const fileBase64 = await toBase64(file);

      const itemToInclude = {
        file: file,
        id: uuidv4(),
        name: file.name,
        contentType: file.type,
        contentByte: fileBase64.split(',')[1]
      };

      const fileWithSameName = filesAnexo.find(fileAnexo => file.name === fileAnexo.name);

      if (fileWithSameName) {
        filesUploadedWithSameName.push(itemToInclude);
        filesWithSameName.push(fileWithSameName);

        setOpenUploadSameFileDialog(true);
      } else {
        listArquivos.push(itemToInclude);
      }
    }

    if (filesUploadedWithSameName) {
      setFilesUploadedWithSameName(filesUploadedWithSameName, 1);
    }

    if (filesWithSameName) {
      setSameFilesUploaded(filesWithSameName);
    }

    setFilesAnexo([...filesAnexo, ...listArquivos]);
  }

  return (
    <div className={classes.root}>
      <DialogCustom
        open={openUploadSameFileDialog}
        handleClose={handleCloseUploadSameFileDialog}
        handleChange={handleReplaceSameFile}
        title={props.t(`forms.dialog.alert`)}
        body={props.t("forms.dialog.uploadSameFile")}
        confirmText={props.t(`forms.dialog.yes`)}
        cancelText={props.t(`forms.dialog.no`)}
        alert={true}
      />
      
      <Grid container >
        <Grid item xs={12}>
          <Textarea
            name="for"
            id="for"
            label={props.t("forms.forLabel")}
            error={emails ? false : true}
            onChange={(event) => {
              setEmails(event.target.value);
            }}
            value={emails}
          />
        </Grid>

        <Grid item xs={8} style={{ marginTop: '1%', width: '100%' }}>
          <TextField
            name="subject"
            id="subject"
            label={props.t("meeting.subject")}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            required
            autoComplete="nope"
            disabled={true}
            value={props.typeFormSend === 'Slot'
              ? `${props?.meetingData?.committeName} - ${props?.meetingData?.meetDate} - ${props.data.name.props.children }`
              : `${props?.meetingData?.committeName} - ${props?.meetingData?.meetDate} - ${props?.meetingData?.meetStartTime} - ${props?.meetingData?.meetEndTime}`}
          />
        </Grid>
      </Grid>
      
      <Grid container >
        {!onlineMeet && (
          <Grid item xs={6} style={{ marginTop: '1%' }}>
            <TextField
              name="place"
              id="place"
              autoCompdlete="nope"
              fullWidth
              label="Local"
              value={slotLocation}
              onChange={(event) => { setSlotLocation(event.target.value) }}
            />
          </Grid>
        )}
        <Grid item xs={6} style={{ marginTop: '1%' }}>
          <FormControlLabel
            fullWidth
            control={
              <Checkbox
                value={onlineMeet}
                checked={onlineMeet}
                onChange={() => setOnlineMeet(!onlineMeet)}
                name="onlineMeet"
                id="onlineMeet"
                color="primary"
              />
            }
            label={props.t("meeting.onlineMeet")}
          />
        </Grid>
      </Grid>
      
      <br />
      
      <Grid container spacing={3} >
        <Grid item lg={4} xs={12} style={{ width: '20%', display: 'inline-block' }}>
          <Typography style={{ textAlign: 'left' }} >{props.t("meeting.startDate")}</Typography>
          <TextField
            name="startDate"
            id="startDate"
            required
            autoComplete="nope"
            fullWidth
            disabled={true}
            value={props?.meetingData?.meetDate || ''}
          />
          <Typography style={{ textAlign: 'left', marginTop: '16px' }} >{props.t("meeting.endDateSendEmail")}</Typography>
          <TextField
            className="endDate"
            name="endDate"
            id="endDate"
            required
            autoComplete="nope"
            fullWidth
            disabled={true}
            value={props?.meetingData?.meetDate || ''}
          />
        </Grid>
        
        <Grid item lg={4} xs={12} style={{ width: '20%', display: 'inline-block' }}>
          <Typography style={{ textAlign: 'left' }} >{props.t("forms.startHour")}</Typography>
          <TextField
            name="startTime"
            id="startTime"
            required
            autoComplete="nope"
            type="time"
            fullWidth
            disabled={true}
            value={props?.data?.meetStartTime || ''}
          />
          <Typography style={{ textAlign: 'left', marginTop: '16px' }} >{props.t("forms.startHour")}</Typography>
          <TextField
            name="endTime"
            id="endTime"
            required
            autoComplete="nope"
            type="time"
            fullWidth
            disabled={true}
            value={props?.data?.meetEndTime || ''}
          />
        </Grid>
      </Grid>
      
      <center>
        <Grid>
          <Button
            variant="contained"
            color="primary"
            component="label"
            style={{ width: '20%', marginTop: '2%' }}
            fullWidth
          >
            {props.t("forms.attachFiles")}
            <input
              type="file"
              hidden
              multiple
              onClick={(event) => {
                event.target.value = null
              }}
              onChange={handleCapture}
            />
          </Button>

          <Dropzone
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
            style={fileOver ? { borderColor: '#465eb6' } : {}}
          >
            {props.t("forms.dragFilesHere")}
          </Dropzone>

          <Box className={classes.lgpdInfoContainer}>
            <FieldInfo>
            {props.t("forms.checkFileAlert")}
            </FieldInfo>
          </Box>
        </Grid>

        <br />

        <Grid item lg={12} xs={12}>
          {filesAnexo.map((item) => (
            <FilesContainer key={item.id}>
              <p>{item.name}</p>
              <DeleteOutlined onClick={() => handleRemoveFile(item.id)} />
            </FilesContainer>
          ))}
        </Grid>
      </center>

      <br />

      <CKEditor
        placeholder={props.t("forms.bodyEmailPlaceholder")}
        editor={ClassicEditor}
        config={{
          toolbar: ['heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList'],
        }}
        data={content}
        onChange={(event, editor) => {
          if (bodyTimeout) {
            clearTimeout(bodyTimeout);
          }

          bodyTimeout = setTimeout(
              () => {
                setContent(editor.getData());
              }, 
            300
          );
        }}
        onBlur={(event, editor) => {
          setContent(editor.getData());
        }}
      />
      
      <br />
      <br />

      <Grid style={{ float: 'right', marginTop: '1%' }}>
        {
          props.enableSendEmail ?
            (
              <Button style={{ width: '20%' }} color="primary" variant="contained" onClick={() => sendEmail()} disabled={loading}>
                {loading ? <CircularProgress size={24} /> : 'Enviar'}
              </Button>
            ) : <br />
        }

        <ToastMessage
          message={toastMessage.message}
          type={toastMessage.type || 'error'}
          open={toastMessage.open}
          close={() => setToastMessage({ ...toastMessage, open: false })}
        />
      </Grid>
    </div>
  );
}

export default FormSendMeetingInvite;